import { useMytaverseEvent } from '../../../../providers';

import { IActiveChannelItem } from './interfaces';
import { IParticipant } from '../../../../../../interfaces/participants';
import { IActivePrivateChannel } from '../../../../../../interfaces/channel';

export const useGetActiveChannelData = () => {
  const { participants, streamChatMemberId } = useMytaverseEvent();

  const getActiveChannelData = (
    activePrivateChannel: IActivePrivateChannel,
  ): IActiveChannelItem | null => {
    if (!activePrivateChannel) return null;

    // reverse find my participant data
    const myParticipantData = participants.find(
      (participant) => participant.streamChatMemberId === streamChatMemberId,
    ) as IParticipant;

    const memberId = activePrivateChannel.userIds.find(
      (userId) => userId !== myParticipantData.participantId,
    );
    const participant = participants.find(
      (participant) => participant.participantId === memberId,
    ) as IParticipant;

    return { participant, privateChannel: activePrivateChannel };
  };

  return getActiveChannelData;
};
